var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127.518,
    height: 32.991,
    viewBox: "0 0 127.518 32.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29235c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29235c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-148.72 -779.76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.77,803.295l-13.05-22.582.149-.081a5.309,5.309,0,0,1,7.252,1.944l5.648,9.743,5.614-9.731a5.525,5.525,0,0,1,4.622-2.668,5.418,5.418,0,0,1,2.638.711l.149.081-.085.147Z",
    transform: "translate(0 -0.148)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.1,803.053h-.166a4.754,4.754,0,0,1-4.359-2.65l0,0a4.7,4.7,0,0,1-.537-2.244v-6.71a6.527,6.527,0,0,0-11.158-4.616,6.314,6.314,0,0,0-1.906,4.616,6.417,6.417,0,0,0,1.906,4.639,6.312,6.312,0,0,0,4.614,1.9h1.954a4.926,4.926,0,0,1,4.922,4.9v.166H502.49a11.607,11.607,0,1,1,0-23.215h.589a10.983,10.983,0,0,1,1.253.144,7.206,7.206,0,0,1,1.342.288,8.415,8.415,0,0,1,1.238.429,12.739,12.739,0,0,1,2.312,1.288l.067.044a13.44,13.44,0,0,1,1.411,1.195,11.242,11.242,0,0,1,3.395,8.219Z",
    transform: "translate(-316.536 -0.072)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.162,812.823H843.555v-.166a4.752,4.752,0,0,1,2.651-4.359,4.875,4.875,0,0,1,2.27-.539h6.686a6.587,6.587,0,0,0,6.543-6.544v-.172a11.647,11.647,0,0,1-13.04.027,11.614,11.614,0,0,1-5.111-9.625,11.621,11.621,0,0,1,11.607-11.608H866.77V780a4.908,4.908,0,0,1-4.9,4.9h-6.709a6.247,6.247,0,0,0-4.613,1.928,6.549,6.549,0,0,0-1.632,6.5,6.585,6.585,0,0,0,2.848,3.7,6.308,6.308,0,0,0,3.4.941,6.468,6.468,0,0,0,3.422-.942,6.582,6.582,0,0,0,2.847-3.7,6.309,6.309,0,0,0,.275-1.88,4.646,4.646,0,0,1,1.1-3.1,4.725,4.725,0,0,1,3.8-1.826h.166v14.691a11.62,11.62,0,0,1-11.607,11.608Z",
    transform: "translate(-642.793 -0.072)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.39 779.772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1204.645,801.674a11.481,11.481,0,1,1,8.122,3.343A11.037,11.037,0,0,1,1204.645,801.674Zm12.831-3.366a6.71,6.71,0,0,0-4.708-11.442,6.709,6.709,0,0,0-4.756,11.442,6.543,6.543,0,0,0,4.756,1.954A6.437,6.437,0,0,0,1217.476,798.308Z",
    transform: "translate(-1201.136 -781.968)",
    fill: "#1fc1cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.717,803.135a11.619,11.619,0,1,1,8.192-3.392A11.265,11.265,0,0,1,1210.717,803.135Zm0-22.883a10.944,10.944,0,0,0-8.005,3.295,10.777,10.777,0,0,0-3.294,7.981,11.287,11.287,0,0,0,22.575,0,11.288,11.288,0,0,0-11.275-11.276Zm0,18.128a6.738,6.738,0,0,1-4.872-2,6.876,6.876,0,0,1,4.872-11.726,6.864,6.864,0,0,1,0,13.728Zm0-13.4a6.543,6.543,0,0,0-4.639,11.159,6.418,6.418,0,0,0,4.639,1.905,6.287,6.287,0,0,0,4.591-1.905h0a6.544,6.544,0,0,0-4.592-11.158Z",
    transform: "translate(-1199.086 -779.92)",
    fill: "#1fc1cb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1560.836,783.152a11.59,11.59,0,1,0,3.415,8.216A11.21,11.21,0,0,0,1560.836,783.152Zm-1.672,8.216a6.25,6.25,0,0,1-1.928,4.614h0a6.287,6.287,0,0,1-4.591,1.9,6.417,6.417,0,0,1-4.639-1.9,6.544,6.544,0,0,1,4.639-11.159,6.587,6.587,0,0,1,6.52,6.544Z",
    transform: "translate(-1288.013)",
    fill: "#1fc1cb"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.e3280041.svg";
export { ForwardRef as ReactComponent };